import ApiPagingRequestModel from '../../generated/types/model/resource/ApiPagingRequestModel';

export default class ApiPagingRequestViewModel extends ApiPagingRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
